import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Reveal } from "../components/ui/reveal";
/**
 * The eyebrow and the title, without block chrome — so a component harness
 * renders exactly what a page renders.
 *
 * The title is an `<h2>`, and that is load-bearing rather than incidental. A
 * Statement declares what a passage of a page is about, so it belongs in the
 * page's outline; a renderer that emitted it as body copy would leave every word
 * present and the structure wrong. But it never OPENS a page — something else
 * already did — so it must not be an `<h1>` either. `compose-statement.spec.ts`
 * asserts the tag, so this cannot drift unnoticed.
 *
 * That is the exact inverse of `CalloutView`, whose statement must stay a `<p>`
 * precisely so it never claims a place in the outline.
 *
 * The eyebrow keeps its guard even though `StatementData.eyebrow` is required.
 * `PromoView` does the same: authoring refuses a blank eyebrow, but pages that
 * construct `StatementData` in code are not routed through that validator, and a
 * missing eyebrow should render as absent rather than as an empty line.
 *
 * `data-statement-renderer` is deliberately NOT here: it belongs to the harness
 * route. A hardcoded Statement already ships on the live /our-story page, and a
 * renderer hook on this component would make a production marketing page answer
 * to the acceptance drivers' locator.
 */
export function StatementView({ data }) {
    return (_jsxs(Reveal, { className: "flex w-full max-w-[1134px] flex-col items-center gap-4 @min-[901px]:px-10", children: [data.eyebrow && (_jsx("p", { "data-statement-eyebrow": true, className: "type-eyebrow-lg", children: data.eyebrow })), _jsx("h2", { "data-statement-title": true, className: "max-w-[1054px] text-balance font-display text-brand-blue text-[clamp(44px,13cqw,64px)] font-light leading-none tracking-[-0.02em] @min-[901px]:text-[64px]", children: data.title })] }));
}
/**
 * StatementBlock — the centered Our Mission treatment from the Our Story
 * prototype. Its height follows its content; only the authored section padding
 * and responsive typography are retained from the prototype.
 */
export function StatementBlock({ data }) {
    return (_jsx("section", { className: "relative z-[2] flex w-full items-center justify-center px-[6.667cqw] text-center text-foreground", children: _jsx(StatementView, { data: data }) }));
}
export function statementFromBlock(block, _resolve) {
    const scalars = block.scalars ?? {};
    return {
        eyebrow: scalars.eyebrow?.trim() ?? "",
        title: scalars.title ?? "",
    };
}
export const statementBlockEntry = {
    Component: StatementBlock,
    fromBlock: statementFromBlock,
};
//# sourceMappingURL=statement.js.map